import Modal from '@components/App/Modal/Modal'
import NotificationWrapper from '@components/App/NotificationContainer/NotificationWrapper'
import SystemDialogs from '@components/App/SystemDialogs'
import { Account as AccountPage, DashboardLayout } from '@components/Dashboard'
import type React from 'react'

import { AuthenticatedWrapper } from './AuthenticatedWrapper'

export const Account: React.FC = () => (
  <AuthenticatedWrapper>
    <NotificationWrapper />
    <DashboardLayout>
      <AccountPage />
    </DashboardLayout>
    <SystemDialogs />
    <Modal />
  </AuthenticatedWrapper>
)
